import { render } from "./ProfileCenters.vue?vue&type=template&id=767e1f36&ts=true"
import script from "./ProfileCenters.vue?vue&type=script&lang=ts"
export * from "./ProfileCenters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Profile/ProfileCenters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "767e1f36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('767e1f36', __exports__)) {
    api.reload('767e1f36', __exports__)
  }
  
  module.hot.accept("./ProfileCenters.vue?vue&type=template&id=767e1f36&ts=true", () => {
    api.rerender('767e1f36', render)
  })

}


export default __exports__